import React from "react"
import { MdHelpOutline } from "react-icons/md"
import { BaseAnchor } from "gatsby-interface"

export function HelpLink({ children = undefined, ...rest }) {
  return (
    <BaseAnchor
      target="_blank"
      css={theme => ({
        display: `inline-flex`,
        alignItems: `center`,
        color: theme.colors.gatsby,
        textDecoration: `none`,
      })}
      {...rest}
    >
      {children}
      <MdHelpOutline
        css={theme => [
          { fontSize: theme.fontSizes[2] },
          children && { marginLeft: theme.space[2] },
        ]}
      />
    </BaseAnchor>
  )
}
